import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../../../client-utils/styled/index.js";
import { coreComponentName } from "../../AppBar.consts.js";
import { OCTUPLE } from "../../../../../constants/numbers.consts.js";
import AvatarButtonAtom from "../../../../../components/atoms/AvatarButton/index.js";
const AvatarButton = styled(AvatarButtonAtom, {
    name: coreComponentName,
    slot: "Avatar",
})(({ theme }) => ({
    width: theme.spacing(OCTUPLE),
    height: theme.spacing(OCTUPLE),
    zIndex: -1, // TODO
}));
export const AppBarAvatarComponent = ({ onClick, ...avatarProps }) => (_jsx(AvatarButton, { "data-testid": "AppBarAvatarButton", "data-tourid": "AppBarAvatarButton", avatarProps: avatarProps, onClick: onClick }));
export default AppBarAvatarComponent;
